import { render, staticRenderFns } from "./InvolucradoPage.vue?vue&type=template&id=4a6c65a8&"
import script from "./InvolucradoPage.vue?vue&type=script&lang=js&"
export * from "./InvolucradoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports